import {
  useGenerateValidationCode,
  useLoginWithEmailValidationCode,
  useMe,
} from '@app/api';
import QueryString from 'qs';
import { useCallback, useEffect, useState } from 'react';

export const useGenerateToMobileQrcodeUrl = (): [
  string | undefined,
  () => Promise<void>,
] => {
  const { mutateAsync: generateConnectionCode } = useGenerateValidationCode();
  const [qrCodeUrl, setQrCodeUrl] = useState<string | undefined>(undefined);

  const { data: me } = useMe(true);

  const generateQrCodeUrl = useCallback(async () => {
    const currentUrl = new URL(window.location.href);
    if (
      currentUrl.searchParams.has('error') &&
      currentUrl.searchParams.get('error') === 'INVALID_DEVICE'
    ) {
      currentUrl.searchParams.delete('error');
    }
    if (me) {
      const codeGenerated = await generateConnectionCode();
      currentUrl.searchParams.set('code', codeGenerated.code);
      currentUrl.searchParams.set('accountId', me.id);
    }
    setQrCodeUrl(currentUrl.toString());
  }, [generateConnectionCode, setQrCodeUrl]);

  return [qrCodeUrl, generateQrCodeUrl];
};

export const useLoginFromQrCodeUrl = () => {
  const { data: me } = useMe(true);
  const { mutate: login, isLoading, error } = useLoginWithEmailValidationCode();
  const params = QueryString.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  const accountId = params.accountId ? String(params.accountId) : undefined;
  const code = params.code ? String(params.code) : undefined;

  useEffect(() => {
    if (!!me || !code || !accountId || isLoading || error) {
      return;
    }
    login({ accountId, code });
  }, [code, accountId, me, isLoading, error]);
};
